import React, { useState } from 'react';

const SuccessModal = ({ isOpen, onClose, photoCount, sessionId }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const shareLink = `${window.location.origin}?session=${sessionId}`;

  const copyLink = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-4 sm:p-6 md:p-8 animate-slide-up">
        {/* Success Icon */}
        <div className="text-center mb-3 sm:mb-4 md:mb-6">
          <div className="inline-block">
            <span className="text-5xl sm:text-6xl md:text-7xl">✅</span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-gray-800 mb-2 sm:mb-3 md:mb-4">
          Upload Complete!
        </h2>

        {/* Message */}
        <p className="text-center text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4 md:mb-6">
          Successfully uploaded <span className="font-bold text-primary-600">{photoCount}</span> photo(s).
          We'll start processing your order shortly.
        </p>

        {/* Share Link */}
        <div className="bg-gray-50 rounded-lg p-2 sm:p-3 md:p-4 mb-3 sm:mb-4 md:mb-6">
          <p className="text-[10px] sm:text-xs md:text-sm text-gray-600 mb-1 sm:mb-2">Share this link to manage photos:</p>
          <div className="flex items-center gap-1 sm:gap-2">
            <input
              type="text"
              value={shareLink}
              readOnly
              className="flex-1 font-mono text-[9px] sm:text-[10px] md:text-xs text-gray-800 bg-white p-1.5 sm:p-2 rounded border focus:outline-none"
            />
            <button
              onClick={copyLink}
              className="px-2 sm:px-3 md:px-4 py-1.5 sm:py-2 bg-primary-600 text-white rounded hover:bg-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap text-xs sm:text-sm"
            >
              {copied ? '✓' : '📋'} <span className="hidden sm:inline">{copied ? 'Copied!' : 'Copy'}</span>
            </button>
          </div>
          <p className="text-[9px] sm:text-[10px] md:text-xs text-gray-500 mt-1 sm:mt-2">
            Anyone with this link can view and manage these photos
          </p>
        </div>

        {/* Action Button */}
        <button
          onClick={() => {
            onClose();
            window.location.href = '/?view=folders';
          }}
          className="w-full bg-primary-600 hover:bg-primary-700 text-white font-semibold py-2.5 sm:py-3 md:py-4 px-4 sm:px-5 md:px-6 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg active:scale-95 transform text-sm sm:text-base"
        >
          📁 View Folders
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;

